// extracted by mini-css-extract-plugin
module.exports = {"nowrap":"style_nowrap__2Naus5yKgTut1yB45q4e_"};